var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiHighProtein(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#e3fb94",
    opacity: 0.5,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5.416 15.05a1.42 1.42 0 010-2.008l1.302-1.302a1.42 1.42 0 012.008 0l3.534 3.534a1.42 1.42 0 010 2.008l-1.302 1.302a1.42 1.42 0 01-2.008 0zm4.332-2.992l2.194 2.194 2.31-2.31-2.194-2.194zm1.992-3.332a1.42 1.42 0 010-2.008l1.302-1.302a1.42 1.42 0 012.008 0l3.534 3.534a1.42 1.42 0 010 2.008l-1.302 1.302a1.42 1.42 0 01-2.008 0z",
    fill: "#31544e",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--high-protein-e5dc08fb1abe19502a1ddb4611f52954.svg";
export { SvgIconUiHighProtein as Component };